import { GetProductionCenterInfoResponse } from "@xlabmedical/medic-api";

export const useProductionCenterStore = defineStore("productionCenter", {
    state: () => ({
        productionCenterList: [] as GetProductionCenterInfoResponse[],
    }),
    actions: {
        async getProductionCenterList() {
            try {
                const { data } = await this.api.getProductionCenters();

                this.productionCenterList = data;
            } catch (error) {
                console.error(error);
            }
        },
        getProductionCenterName(id: number) {
            if (id === 1) {
                return "3Diemme";
            }

            return this.productionCenterList.find((p) => p.id === id)?.displayString ?? "";
        },
    },
});
